export const translations = {
  en: {
    code: 'en',
    label: 'English',
    shortLabel: 'EN',
    nav: {
      aria: 'Main navigation',
      official: 'Official website',
      language: 'Language',
      menu: 'Open menu',
      close: 'Close menu',
      home: 'Home',
      privacy: 'Privacy & Security',
      terms: 'Terms',
      support: 'Support',
      deleteAccount: 'Delete Account'
    },
    footer: {
      tagline: 'Building simple digital tools for everyday people and businesses.',
      privacy: 'Privacy',
      terms: 'Terms',
      support: 'Support'
    },
    home: {
      eyebrow: 'Official website',
      title: '{{appName}} helps clients find barber services with clarity.',
      copy:
        '{{companyName}} is a mobile barber experience for booking appointments, discovering services, and staying connected with trusted barbers. This website gives app store reviewers and customers a simple place to find our business information, privacy details, terms, support options, and account deletion request.',
      supportCta: 'Contact Support',
      privacyCta: 'View Privacy Policy',
      featuresEyebrow: 'What we do',
      featuresTitle: 'A barber app with clear support and responsible data handling.',
      features: [
        'A smooth booking experience designed for clients and barbers.',
        'Secure account access and clear controls for personal data.',
        'Helpful support before and after every appointment.'
      ],
      reviewEyebrow: 'For app review',
      reviewTitle: 'Required pages are ready in one responsive website.'
    },
    privacy: {
      title: 'Privacy & Security',
      intro:
        'This Privacy & Security Policy explains how {{companyName}} collects, uses, protects, and manages information when people use {{appName}}.',
      sections: [
        {
          title: 'Information We Collect',
          body:
            'We may collect account information, contact details, device information, app activity, and support messages when needed to provide and improve our services.'
        },
        {
          title: 'How We Use Information',
          body:
            'We use information to operate the app, authenticate users, provide support, improve app performance, prevent misuse, and communicate important service updates.'
        },
        {
          title: 'Security Practices',
          body:
            'We use reasonable technical and organizational safeguards to protect personal data. No internet service is completely risk-free, but we work to keep user information protected against unauthorized access, loss, misuse, or disclosure.'
        },
        {
          title: 'Sharing Information',
          body:
            'We do not sell personal information. We may share limited information with trusted service providers who help us operate the app, comply with law, or protect the rights and safety of users and our business.'
        },
        {
          title: 'User Choices',
          body:
            'Users may contact us to request access, correction, or deletion of account information. Account deletion requests can be submitted from the Delete Account page.'
        }
      ],
      contactTitle: 'Contact',
      contactText: 'For privacy questions, contact us at'
    },
    terms: {
      title: 'Terms & Conditions',
      intro:
        'These Terms & Conditions describe the rules for using {{appName}}, provided by {{companyName}}.',
      sections: [
        {
          title: 'Acceptance of Terms',
          body:
            'By downloading, accessing, or using the app, users agree to follow these terms and any applicable laws. Users who do not agree should stop using the app.'
        },
        {
          title: 'Use of the App',
          body:
            'Users agree to use the app only for lawful purposes and in a way that does not harm the service, other users, or our business.'
        },
        {
          title: 'Accounts',
          body:
            'Users are responsible for keeping account information accurate and protecting login credentials. We may suspend access if we detect misuse, fraud, or activity that violates these terms.'
        },
        {
          title: 'Intellectual Property',
          body:
            'The app, website, branding, content, and related materials belong to {{companyName}} or its licensors. Users may not copy, modify, or distribute them without permission.'
        },
        {
          title: 'Limitation of Liability',
          body:
            'The app is provided as available. To the maximum extent allowed by law, we are not liable for indirect, incidental, special, or consequential damages related to use of the app.'
        }
      ],
      contactTitle: 'Contact',
      contactText: 'Questions about these terms can be sent to'
    },
    support: {
      title: 'Support',
      intro:
        'Need help with {{appName}}? Our support team can help with account access, app issues, billing questions, and general feedback.',
      contactTitle: 'Contact Support',
      contactText:
        'Email us at {{email}}. Please include your name, account email, device type, and a short description of the issue.',
      emailCta: 'Email Support',
      responseTitle: 'Response Time',
      responseText:
        'We aim to respond to support requests within 2 business days. Complex account or security requests may take longer if we need to verify ownership.',
      detailsTitle: 'Helpful Details to Send',
      details: [
        'The email address connected to your account.',
        'The app version and device model you are using.',
        'Screenshots or error messages, if available.',
        'The steps you tried before contacting support.'
      ]
    },
    deleteAccount: {
      title: 'Delete Account',
      intro:
        'Users can request deletion of their {{appName}} account and associated personal data using the instructions below.',
      requestTitle: 'Request Account Deletion',
      requestText:
        'Start a deletion request by entering the email address connected to your account. We will send a confirmation email with a secure link to continue account deletion.',
      requestCta: 'Start Deletion Request',
      includeTitle: 'What to Include',
      include: [
        'The email address connected to your account.',
        'Access to that email inbox so you can confirm the request.',
        'Confirmation from the secure email link before deletion continues.'
      ],
      nextTitle: 'What Happens Next',
      nextText:
        'After you submit your email address, our system sends a confirmation email. The email contains a secure link that verifies account ownership and starts the deletion process.',
      timeTitle: 'Processing Time',
      timeText: 'Account deletion requests are typically completed within 30 days after verification.',
      emailSubject: 'Delete My Account'
    },
    deleteRequest: {
      title: 'Start Deletion Request',
      intro:
        'Enter the email address connected to your {{appName}} account. We will send a confirmation email with a secure deletion link.',
      formTitle: 'Enter Your Account Email',
      formText:
        'Use the same email address you use for your CityBarber account. The deletion link will be sent to this address.',
      emailLabel: 'Email address',
      emailPlaceholder: 'name@example.com',
      submitCta: 'Send Deletion Email',
      submittingCta: 'Sending...',
      successMessage:
        'If {{email}} is connected to a {{appName}} account, a confirmation email will be sent shortly.',
      errorMessage:
        'We could not send the deletion email right now. Please try again later or contact support.',
      emailTitle: 'Check Your Email',
      emailText:
        'Open the email from CityBarber and click the secure deletion link. The account deletion process will not continue until the link is confirmed.',
      backendTitle: 'Security Note',
      backendText:
        'For your safety, the secure deletion link is created and sent by our backend. The website only collects the email address and sends it securely to our deletion request service.'
    },
    notFound: {
      eyebrow: 'Page not found',
      title: 'We could not find that page.',
      text: 'The page may have moved, or the address may be incorrect.',
      cta: 'Go Home'
    }
  },
  sq: {
    code: 'sq',
    label: 'Shqip',
    shortLabel: 'SQ',
    nav: {
      aria: 'Navigimi kryesor',
      official: 'Faqja zyrtare',
      language: 'Gjuha',
      menu: 'Hap menunë',
      close: 'Mbyll menunë',
      home: 'Ballina',
      privacy: 'Privatësia & Siguria',
      terms: 'Kushtet',
      support: 'Mbështetje',
      deleteAccount: 'Fshi llogarinë'
    },
    footer: {
      tagline: 'Ndërtojmë mjete të thjeshta digjitale për njerëz dhe biznese të përditshme.',
      privacy: 'Privatësia',
      terms: 'Kushtet',
      support: 'Mbështetje'
    },
    home: {
      eyebrow: 'Faqja zyrtare',
      title: '{{appName}} i ndihmon klientët të gjejnë shërbime berberi me qartësi.',
      copy:
        '{{companyName}} është një përvojë mobile për berberë, e krijuar për rezervime, shërbime dhe lidhje me berberë të besuar. Kjo faqe u jep recensuesve të dyqaneve të aplikacioneve dhe klientëve një vend të thjeshtë për të gjetur informacionin e biznesit, privatësinë, kushtet, mbështetjen dhe kërkesën për fshirjen e llogarisë.',
      supportCta: 'Kontakto mbështetjen',
      privacyCta: 'Shiko politikën e privatësisë',
      featuresEyebrow: 'Çfarë bëjmë',
      featuresTitle: 'Aplikacion berberi me mbështetje të qartë dhe trajtim të përgjegjshëm të të dhënave.',
      features: [
        'Përvojë e qetë rezervimi për klientë dhe berberë.',
        'Qasje e sigurt në llogari dhe kontroll i qartë për të dhënat personale.',
        'Mbështetje e dobishme para dhe pas çdo termini.'
      ],
      reviewEyebrow: 'Për kontrollin e aplikacionit',
      reviewTitle: 'Faqet e kërkuara janë gati në një uebfaqe responsive.'
    },
    privacy: {
      title: 'Privatësia & Siguria',
      intro:
        'Kjo Politikë e Privatësisë dhe Sigurisë shpjegon si {{companyName}} mbledh, përdor, mbron dhe menaxhon informacionin kur njerëzit përdorin {{appName}}.',
      sections: [
        {
          title: 'Informacioni që mbledhim',
          body:
            'Mund të mbledhim informacion të llogarisë, të dhëna kontakti, informacion të pajisjes, aktivitet në aplikacion dhe mesazhe mbështetjeje kur nevojiten për të ofruar dhe përmirësuar shërbimet tona.'
        },
        {
          title: 'Si e përdorim informacionin',
          body:
            'E përdorim informacionin për të operuar aplikacionin, për të autentikuar përdoruesit, për të ofruar mbështetje, për të përmirësuar performancën, për të parandaluar keqpërdorimin dhe për të komunikuar përditësime të rëndësishme.'
        },
        {
          title: 'Praktikat e sigurisë',
          body:
            'Përdorim masa të arsyeshme teknike dhe organizative për të mbrojtur të dhënat personale. Asnjë shërbim interneti nuk është plotësisht pa rrezik, por ne punojmë për të mbrojtur informacionin e përdoruesve nga qasja, humbja, keqpërdorimi ose zbulimi i paautorizuar.'
        },
        {
          title: 'Ndarja e informacionit',
          body:
            'Ne nuk shesim informacion personal. Mund të ndajmë informacion të kufizuar me ofrues të besuar shërbimesh që na ndihmojnë të operojmë aplikacionin, të respektojmë ligjin ose të mbrojmë të drejtat dhe sigurinë e përdoruesve dhe biznesit tonë.'
        },
        {
          title: 'Zgjedhjet e përdoruesit',
          body:
            'Përdoruesit mund të na kontaktojnë për të kërkuar qasje, korrigjim ose fshirje të informacionit të llogarisë. Kërkesat për fshirjen e llogarisë mund të dërgohen nga faqja Fshi llogarinë.'
        }
      ],
      contactTitle: 'Kontakt',
      contactText: 'Për pyetje rreth privatësisë, na kontaktoni në'
    },
    terms: {
      title: 'Kushtet & Rregullat',
      intro:
        'Këto Kushte & Rregulla përshkruajnë rregullat për përdorimin e {{appName}}, të ofruar nga {{companyName}}.',
      sections: [
        {
          title: 'Pranimi i kushteve',
          body:
            'Duke shkarkuar, hapur ose përdorur aplikacionin, përdoruesit pajtohen t’i ndjekin këto kushte dhe ligjet e zbatueshme. Përdoruesit që nuk pajtohen duhet të ndalojnë përdorimin e aplikacionit.'
        },
        {
          title: 'Përdorimi i aplikacionit',
          body:
            'Përdoruesit pajtohen ta përdorin aplikacionin vetëm për qëllime të ligjshme dhe në mënyrë që nuk dëmton shërbimin, përdoruesit e tjerë ose biznesin tonë.'
        },
        {
          title: 'Llogaritë',
          body:
            'Përdoruesit janë përgjegjës për saktësinë e informacionit të llogarisë dhe mbrojtjen e kredencialeve të hyrjes. Mund të pezullojmë qasjen nëse zbulojmë keqpërdorim, mashtrim ose aktivitet që shkel këto kushte.'
        },
        {
          title: 'Pronësia intelektuale',
          body:
            'Aplikacioni, uebfaqja, marka, përmbajtja dhe materialet përkatëse i përkasin {{companyName}} ose licencuesve të saj. Përdoruesit nuk mund t’i kopjojnë, ndryshojnë ose shpërndajnë pa leje.'
        },
        {
          title: 'Kufizimi i përgjegjësisë',
          body:
            'Aplikacioni ofrohet siç është i disponueshëm. Në masën maksimale të lejuar nga ligji, ne nuk mbajmë përgjegjësi për dëme indirekte, të rastësishme, të veçanta ose pasuese lidhur me përdorimin e aplikacionit.'
        }
      ],
      contactTitle: 'Kontakt',
      contactText: 'Pyetjet për këto kushte mund të dërgohen në'
    },
    support: {
      title: 'Mbështetje',
      intro:
        'Keni nevojë për ndihmë me {{appName}}? Ekipi ynë i mbështetjes mund të ndihmojë me qasjen në llogari, problemet e aplikacionit, pyetjet e faturimit dhe komentet e përgjithshme.',
      contactTitle: 'Kontakto mbështetjen',
      contactText:
        'Na dërgoni email në {{email}}. Ju lutemi përfshini emrin tuaj, emailin e llogarisë, llojin e pajisjes dhe një përshkrim të shkurtër të problemit.',
      emailCta: 'Dërgo email',
      responseTitle: 'Koha e përgjigjes',
      responseText:
        'Synojmë t’u përgjigjemi kërkesave për mbështetje brenda 2 ditëve të punës. Kërkesat komplekse të llogarisë ose sigurisë mund të zgjasin më shumë nëse duhet të verifikojmë pronësinë.',
      detailsTitle: 'Detaje të dobishme për t’i dërguar',
      details: [
        'Adresa e emailit e lidhur me llogarinë tuaj.',
        'Versioni i aplikacionit dhe modeli i pajisjes që përdorni.',
        'Pamje ekrani ose mesazhe gabimi, nëse ka.',
        'Hapat që keni provuar para se të kontaktoni mbështetjen.'
      ]
    },
    deleteAccount: {
      title: 'Fshi llogarinë',
      intro:
        'Përdoruesit mund të kërkojnë fshirjen e llogarisë së tyre në {{appName}} dhe të dhënave personale të lidhura duke ndjekur udhëzimet më poshtë.',
      requestTitle: 'Kërko fshirjen e llogarisë',
      requestText:
        'Filloni kërkesën për fshirje duke shkruar adresën e emailit të lidhur me llogarinë tuaj. Do të dërgojmë një email konfirmimi me një link të sigurt për të vazhduar fshirjen e llogarisë.',
      requestCta: 'Fillo kërkesën për fshirje',
      includeTitle: 'Çfarë duhet të përfshini',
      include: [
        'Adresën e emailit të lidhur me llogarinë tuaj.',
        'Qasje në atë inbox që të mund ta konfirmoni kërkesën.',
        'Konfirmim nga linku i sigurt në email para se fshirja të vazhdojë.'
      ],
      nextTitle: 'Çfarë ndodh më pas',
      nextText:
        'Pasi të dërgoni adresën e emailit, sistemi ynë dërgon një email konfirmimi. Emaili përmban një link të sigurt që verifikon pronësinë e llogarisë dhe fillon procesin e fshirjes.',
      timeTitle: 'Koha e përpunimit',
      timeText: 'Kërkesat për fshirjen e llogarisë zakonisht përfundohen brenda 30 ditëve pas verifikimit.',
      emailSubject: 'Delete My Account'
    },
    deleteRequest: {
      title: 'Fillo kërkesën për fshirje',
      intro:
        'Shkruani adresën e emailit të lidhur me llogarinë tuaj në {{appName}}. Do të dërgojmë një email konfirmimi me një link të sigurt fshirjeje.',
      formTitle: 'Shkruani emailin e llogarisë',
      formText:
        'Përdorni të njëjtën adresë emaili që përdorni për llogarinë tuaj CityBarber. Linku i fshirjes do të dërgohet në këtë adresë.',
      emailLabel: 'Adresa e emailit',
      emailPlaceholder: 'emri@example.com',
      submitCta: 'Dërgo emailin e fshirjes',
      submittingCta: 'Duke dërguar...',
      successMessage:
        'Nëse {{email}} është i lidhur me një llogari {{appName}}, emaili i konfirmimit do të dërgohet së shpejti.',
      errorMessage:
        'Nuk mundëm ta dërgojmë emailin e fshirjes tani. Ju lutemi provoni përsëri më vonë ose kontaktoni mbështetjen.',
      emailTitle: 'Kontrolloni emailin',
      emailText:
        'Hapni emailin nga CityBarber dhe klikoni linkun e sigurt të fshirjes. Procesi i fshirjes së llogarisë nuk vazhdon derisa linku të konfirmohet.',
      backendTitle: 'Shënim sigurie',
      backendText:
        'Për sigurinë tuaj, linku i sigurt i fshirjes krijohet dhe dërgohet nga backend-i ynë. Uebfaqja vetëm mbledh adresën e emailit dhe e dërgon në mënyrë të sigurt te shërbimi i kërkesës për fshirje.'
    },
    notFound: {
      eyebrow: 'Faqja nuk u gjet',
      title: 'Nuk mund ta gjenim atë faqe.',
      text: 'Faqja mund të jetë zhvendosur ose adresa mund të jetë e pasaktë.',
      cta: 'Kthehu në ballinë'
    }
  },
  mk: {
    code: 'mk',
    label: 'Македонски',
    shortLabel: 'MK',
    nav: {
      aria: 'Главна навигација',
      official: 'Официјална веб-страница',
      language: 'Јазик',
      menu: 'Отвори мени',
      close: 'Затвори мени',
      home: 'Почетна',
      privacy: 'Приватност & Безбедност',
      terms: 'Услови',
      support: 'Поддршка',
      deleteAccount: 'Избриши сметка'
    },
    footer: {
      tagline: 'Создаваме едноставни дигитални алатки за луѓе и бизниси.',
      privacy: 'Приватност',
      terms: 'Услови',
      support: 'Поддршка'
    },
    home: {
      eyebrow: 'Официјална веб-страница',
      title: '{{appName}} им помага на клиентите јасно да најдат берберски услуги.',
      copy:
        '{{companyName}} е мобилно берберско искуство за резервирање термини, откривање услуги и поврзување со доверливи бербери. Оваа веб-страница им дава на рецензентите од продавниците за апликации и на клиентите едноставно место за деловни информации, приватност, услови, поддршка и барање за бришење сметка.',
      supportCta: 'Контактирај поддршка',
      privacyCta: 'Види политика за приватност',
      featuresEyebrow: 'Што правиме',
      featuresTitle: 'Берберска апликација со јасна поддршка и одговорно ракување со податоци.',
      features: [
        'Непречено искуство за резервации за клиенти и бербери.',
        'Безбеден пристап до сметка и јасни контроли за лични податоци.',
        'Корисна поддршка пред и по секој термин.'
      ],
      reviewEyebrow: 'За преглед на апликацијата',
      reviewTitle: 'Потребните страници се подготвени во една responsive веб-страница.'
    },
    privacy: {
      title: 'Приватност & Безбедност',
      intro:
        'Оваа Политика за приватност и безбедност објаснува како {{companyName}} собира, користи, заштитува и управува со информации кога луѓето ја користат {{appName}}.',
      sections: [
        {
          title: 'Информации што ги собираме',
          body:
            'Може да собираме информации за сметка, контакт податоци, информации за уред, активност во апликацијата и пораки до поддршка кога тоа е потребно за да ги обезбедиме и подобриме нашите услуги.'
        },
        {
          title: 'Како ги користиме информациите',
          body:
            'Информациите ги користиме за работа на апликацијата, автентикација на корисници, поддршка, подобрување на перформансите, спречување злоупотреба и испраќање важни сервисни известувања.'
        },
        {
          title: 'Безбедносни практики',
          body:
            'Користиме разумни технички и организациски мерки за заштита на личните податоци. Ниту една интернет услуга не е целосно без ризик, но работиме на заштита на корисничките информации од неовластен пристап, губење, злоупотреба или откривање.'
        },
        {
          title: 'Споделување информации',
          body:
            'Не продаваме лични информации. Може да споделиме ограничени информации со доверливи даватели на услуги кои ни помагаат да ја одржуваме апликацијата, да го почитуваме законот или да ги заштитиме правата и безбедноста на корисниците и нашиот бизнис.'
        },
        {
          title: 'Избори на корисникот',
          body:
            'Корисниците може да не контактираат за пристап, исправка или бришење информации за сметка. Барањата за бришење сметка може да се поднесат преку страницата Избриши сметка.'
        }
      ],
      contactTitle: 'Контакт',
      contactText: 'За прашања за приватност, контактирајте не на'
    },
    terms: {
      title: 'Услови & Правила',
      intro:
        'Овие Услови & Правила ги опишуваат правилата за користење на {{appName}}, обезбедена од {{companyName}}.',
      sections: [
        {
          title: 'Прифаќање на условите',
          body:
            'Со преземање, пристапување или користење на апликацијата, корисниците се согласуваат да ги следат овие услови и важечките закони. Корисниците кои не се согласуваат треба да престанат да ја користат апликацијата.'
        },
        {
          title: 'Користење на апликацијата',
          body:
            'Корисниците се согласуваат да ја користат апликацијата само за законски цели и на начин што не ја оштетува услугата, другите корисници или нашиот бизнис.'
        },
        {
          title: 'Сметки',
          body:
            'Корисниците се одговорни за точноста на информациите за сметка и за заштита на податоците за најава. Може да го суспендираме пристапот ако откриеме злоупотреба, измама или активност што ги прекршува овие услови.'
        },
        {
          title: 'Интелектуална сопственост',
          body:
            'Апликацијата, веб-страницата, брендот, содржината и поврзаните материјали припаѓаат на {{companyName}} или на нејзините лиценцодавци. Корисниците не смеат да ги копираат, изменуваат или дистрибуираат без дозвола.'
        },
        {
          title: 'Ограничување на одговорност',
          body:
            'Апликацијата се обезбедува како достапна. Во најголема мера дозволена со закон, не сме одговорни за индиректни, случајни, посебни или последични штети поврзани со користење на апликацијата.'
        }
      ],
      contactTitle: 'Контакт',
      contactText: 'Прашања за овие услови може да се испратат на'
    },
    support: {
      title: 'Поддршка',
      intro:
        'Ви треба помош со {{appName}}? Нашиот тим за поддршка може да помогне со пристап до сметка, проблеми со апликацијата, прашања за наплата и општи коментари.',
      contactTitle: 'Контактирај поддршка',
      contactText:
        'Испратете ни email на {{email}}. Ве молиме вклучете го вашето име, email на сметката, тип на уред и краток опис на проблемот.',
      emailCta: 'Испрати email',
      responseTitle: 'Време на одговор',
      responseText:
        'Се стремиме да одговориме на барањата за поддршка во рок од 2 работни дена. Посложени барања за сметка или безбедност може да потраат подолго ако треба да ја потврдиме сопственоста.',
      detailsTitle: 'Корисни детали за испраќање',
      details: [
        'Email адресата поврзана со вашата сметка.',
        'Верзијата на апликацијата и моделот на уредот што го користите.',
        'Слики од екран или пораки за грешка, ако има.',
        'Чекорите што ги пробавте пред да контактирате поддршка.'
      ]
    },
    deleteAccount: {
      title: 'Избриши сметка',
      intro:
        'Корисниците може да побараат бришење на нивната сметка во {{appName}} и поврзаните лични податоци преку упатствата подолу.',
      requestTitle: 'Побарај бришење сметка',
      requestText:
        'Започнете барање за бришење со внесување на email адресата поврзана со вашата сметка. Ќе испратиме email за потврда со безбеден линк за продолжување на бришењето на сметката.',
      requestCta: 'Започни барање за бришење',
      includeTitle: 'Што да вклучите',
      include: [
        'Email адресата поврзана со вашата сметка.',
        'Пристап до тој email inbox за да го потврдите барањето.',
        'Потврда преку безбедниот email линк пред бришењето да продолжи.'
      ],
      nextTitle: 'Што следува',
      nextText:
        'Откако ќе ја внесете email адресата, нашиот систем испраќа email за потврда. Email пораката содржи безбеден линк што ја потврдува сопственоста на сметката и го започнува процесот на бришење.',
      timeTitle: 'Време на обработка',
      timeText: 'Барањата за бришење сметка обично се завршуваат во рок од 30 дена по потврда.',
      emailSubject: 'Delete My Account'
    },
    deleteRequest: {
      title: 'Започни барање за бришење',
      intro:
        'Внесете ја email адресата поврзана со вашата {{appName}} сметка. Ќе испратиме email за потврда со безбеден линк за бришење.',
      formTitle: 'Внесете email на сметката',
      formText:
        'Користете ја истата email адреса што ја користите за вашата CityBarber сметка. Линкот за бришење ќе биде испратен на оваа адреса.',
      emailLabel: 'Email адреса',
      emailPlaceholder: 'ime@example.com',
      submitCta: 'Испрати email за бришење',
      submittingCta: 'Се испраќа...',
      successMessage:
        'Ако {{email}} е поврзан со {{appName}} сметка, email за потврда ќе биде испратен наскоро.',
      errorMessage:
        'Не можевме да го испратиме email-от за бришење во моментов. Обидете се повторно подоцна или контактирајте поддршка.',
      emailTitle: 'Проверете го email-от',
      emailText:
        'Отворете го email-от од CityBarber и кликнете го безбедниот линк за бришење. Процесот на бришење сметка нема да продолжи додека линкот не биде потврден.',
      backendTitle: 'Безбедносна забелешка',
      backendText:
        'За ваша безбедност, безбедниот линк за бришење го создава и испраќа нашиот backend. Веб-страницата само ја собира email адресата и ја испраќа безбедно до нашиот сервис за барања за бришење.'
    },
    notFound: {
      eyebrow: 'Страницата не е пронајдена',
      title: 'Не можевме да ја најдеме таа страница.',
      text: 'Страницата можеби е преместена или адресата е неточна.',
      cta: 'Оди на почетна'
    }
  }
};

export function fillTemplate(text, values) {
  return text.replace(/\{\{(\w+)\}\}/g, (_, key) => values[key] || '');
}
